




















import Vue from 'vue';
    // 面版折叠
    export default Vue.extend({
        data() {
            return {
                is_minimized: false,
            };
        },
        computed: {
            isMobile(): boolean {
                return this.$store.state.isMobile;
            },
        },
        watch: {
            isMobile(val) {
                if (val) {
                    window.removeEventListener('resize', this.measure);
                } else {
                    this.panelHeight();
                    window.addEventListener('resize', this.measure);
                }
            },
        },
        mounted() {
            if (!this.isMobile) {
                this.panelHeight();
                window.addEventListener('resize', this.measure);
            }
            window.addEventListener('scroll', this.myScroll);
            if (document.documentElement.clientWidth <= 1280) {
                this.toggle(false);
            }
        },
        methods: {
            measure() {
                if (document.documentElement.clientWidth <= 1280) {
                    this.toggle(false);
                }
            },
            toggle(is_minimized) {
                const panelFoldWarp: any = document.getElementsByClassName('panelFoldWarp')[0];
                const filterWarp: any = document.getElementsByClassName('filterWarp')[0];
                this.is_minimized = !is_minimized;
                if (this.is_minimized) {
                    panelFoldWarp.classList.add('minimized');
                    filterWarp.classList.add('minimized');
                    if (this.isMobile) (document.querySelector('.filterWarp') as any).scrollTop = 0;
                } else {
                    panelFoldWarp.classList.remove('minimized');
                    filterWarp.classList.remove('minimized');
                }
            },
            panelHeight() {
                setTimeout(() => {
                    const panelFoldWarp: any = document.getElementsByClassName('panelFoldWarp')[0];
                    const panelFoldDom: any = document.getElementById('panelFold');
                    const filterWarp: any = document.getElementsByClassName('filterWarp')[0];
                    const panelFoldDomOffsetTop = panelFoldWarp.offsetTop;
                    panelFoldDom.style.height = `${document.documentElement.clientHeight - panelFoldDomOffsetTop}px`;
                    filterWarp.style.maxHeight = panelFoldDom.style.height;
                }, 1000);
            },
            myScroll() {
                const panelFoldWarp: any = document.getElementsByClassName('panelFoldWarp')[0];
                const panelFoldDom: any = document.getElementById('panelFold');
                const filterWarp: any = document.getElementsByClassName('filterWarp')[0];
                const panelFoldDomOffsetTop = panelFoldWarp.offsetTop;
                panelFoldDom.style.height = `${document.documentElement.clientHeight - panelFoldDomOffsetTop}px`;
                const { clientHeight } = document.documentElement;
                const scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
                let distance = 60;
                if (this.isMobile) {
                    distance = this.$route.name === 'BrandDetail' ? 108 : 48;
                } else if (this.$route.name === 'BrandDetail') {
                    distance = 140;
                }
                if (panelFoldDomOffsetTop - scrollTop <= distance) {
                    panelFoldDom.style.position = 'fixed';
                    panelFoldDom.style.top = `${distance}px`;
                    panelFoldDom.style.height = `${clientHeight - distance}px`;
                } else {
                    panelFoldDom.style.position = 'relative';
                    panelFoldDom.style.top = '';
                    panelFoldDom.style.height = `${clientHeight - (panelFoldDomOffsetTop - scrollTop)}px`;
                }
                filterWarp.style.maxHeight = panelFoldDom.style.height;
            },
        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.myScroll);
            window.removeEventListener('resize', this.measure);
        },
    });
